define("shared/utils/analytics/constants/features", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class FeaturesUtil
   * @extends Utils
   *
   * List of all analytics features
   *
   * @property FEATURES
   * @returns {Array.<String>}
   */
  const FEATURES = ['analyticsPerformanceReport', 'analyticsStandard', 'analyticsTableRedesign', 'backfillAnalytics', 'clickTracking', 'conversations', 'export', 'facebook', 'hashtag', 'hashtagTrends', 'libAnalyticsHeatmap', 'linkinbioEmbeddable', 'linkinbioShopify', 'longerAnalytics', 'longerAnalyticsTable', 'pinterest', 'pinterestClickTracking', 'profileCategorization', 'twitter', 'twitterClickTracking', 'tiktokAnalytics', 'instagramReels'];
  var _default = FEATURES;
  _exports.default = _default;
});